import { render, staticRenderFns } from "./success.vue?vue&type=template&id=f9c1359c&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&id=f9c1359c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c1359c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9c1359c')) {
      api.createRecord('f9c1359c', component.options)
    } else {
      api.reload('f9c1359c', component.options)
    }
    module.hot.accept("./success.vue?vue&type=template&id=f9c1359c&scoped=true&", function () {
      api.rerender('f9c1359c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myIntegral/success.vue"
export default component.exports